import { render, staticRenderFns } from "./IconFolderlg.vue?vue&type=template&id=78fe492f&"
import script from "./IconFolderlg.vue?vue&type=script&lang=js&"
export * from "./IconFolderlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78fe492f')) {
      api.createRecord('78fe492f', component.options)
    } else {
      api.reload('78fe492f', component.options)
    }
    module.hot.accept("./IconFolderlg.vue?vue&type=template&id=78fe492f&", function () {
      api.rerender('78fe492f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconFolderlg.vue"
export default component.exports